module.exports = __webpack_public_path__ + "images/d5821d2fe1cce053126e4d8ddce986a8.png";